export const generatePageTitle = ({ name, isApple }) => {
  if (!name) return "";

  return isApple
    ? `${name} - Buy Now! | GCX`
    : `${name} Gift Cards - Buy Now! | GCX`;
};

export const generatePageDescription = ({ name, isApple, metaDescription }) => {
  if (metaDescription) return metaDescription;

  if (name)
    return `Buy ${
      isApple ? `an ${name}` : `a ${name} gift card`
    } online and instantly save an average of 10%. GCX is the smartest way to save every day. Discounts on 4,000+ brands. Guaranteed.`;

  return "";
};
